<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <br><br>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="6"
      >
        <div v-if="!text">
          <canvas
            id="myChart26"
            width="250"
            height="80"
          />
        </div>
        <div
          v-else
        >
          {{ text }}
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="6"
      >
        <v-container>
          <v-row>
            <v-col
              v-if="valorPago"
              id="valorAbertoRecebidoId"
              :style="styleObject"
              cols="12"
              sm="10"
              md="10"
              lg="10"
              class="text-right"
            >
              {{ valorPago }}
            </v-col>
            <v-col
              id="colIconLink"
              cols="12"
              sm="2"
              md="2"
              lg="2"
              class="text-right"
            >
              <router-link
                to="/contas-pagar/valor-a-vencer"
                :style="styleObject"
              >
                <v-icon
                  id="iconLinkDetalheAbertoPago"
                  class="text-left"
                >
                  mdi-dots-vertical
                </v-icon>
              </router-link>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import ContasPagar from '../../../../services/contaspagar'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardValorRecebido',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      myChart: {},
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enableGrafico: true,
      text: null,
      valorPagar: 0,
      valorPago: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      montaGrafico: true,
      percenteExibicao: null,
      primeiroDia: '',
      ultimoDia: '',
      empresa: [],
      loading: false,
      error: null,
      styleObject: {
        color: localStorage.corPrimaria,
      },
    }),

    created () {
      eventEmit.$on('set-valores-pagos', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-valores-pagos', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select

        this.MontarGrafico()
      },

      async MontarGrafico () {
        this.loading = true

        this.valorPago = null

        this.percenteExibicao = null

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await ContasPagar.showRelacaoValoresPagos(this.primeiroDia, this.ultimoDia, this.empresa, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorPago = resposta.data.valorPago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const porcentagemAtiginda = resposta.data.porcentagemAtiginda.toFixed(2)
            const porcentagemRestante = (100 - porcentagemAtiginda).toFixed(2)

            this.percenteExibicao = porcentagemAtiginda.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChart26').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [porcentagemAtiginda, porcentagemRestante],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                maintainAspectRatio: false,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 70,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.percenteExibicao,
                    color: '#000000',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há valores à pagar pagos no período selecionado') {
            this.valorPago = resposta.data.valorPago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.text = resposta.data.mg

            this.error = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #myChart26 {
      width: 166px !important;
      height: 55px !important;
      margin: -3rem 0 0 2rem;
    }

    #valorPagoCP {
      margin: 0 0 0 6.5rem !important;
    }

    #valorPagoRecebidoId {
      font-size: 20px;
      display: grid;
      align-items: center;
      margin: -6rem 0 0 -2rem;
      font-weight: bold;
    }

    #iconLinkDetalhePago {
      margin: -9rem 0 0 0rem;
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart26 {
      width: 166px !important;
      height: 55px !important;
      margin: -7rem 0 0 37rem;
    }

    #valorPagoCP {
      margin: 0 0 0 41.5rem !important;
    }

    #valorPagoRecebidoId {
      font-size: 20px;
      display: grid;
      align-items: center;
      margin: -6.4rem 0 0 32.2rem;
      font-weight: bold;
    }

    #iconLinkDetalhePago {
      margin: -3.75rem 0 0 43.3rem;
    }
  }

  @media screen and (min-width: 1380px) and (max-width: 1799px) {
    #myChart26 {
      margin: -3rem 0 0 1rem;
      height: 51px !important;
      width: 159px !important;
    }

    #valorPagoCP {
      margin: 0rem 0 0 5rem;
    }

    #valorPagoRecebidoId {
      font-size: 19px;
      margin: -3.5rem 0 0 -2rem;
    }

    #iconLinkDetalhePago {
      margin: -3.5rem 0 0 1rem;
    }
  }

  @media screen
  and (min-width: 1800px) {
    #myChart26 {
      margin: -3rem 0 0 4rem;
      width: 195px !important;
      height: 50px !important;
    }

    #valorPagoCP {
      margin: 0rem 0 0 9rem;
    }

    #valorPagoRecebidoId {
      font-size: 20px;
      margin: -2.5rem 0 0 0rem;
    }

    #iconLinkDetalhePago {
      margin: -2.5rem 0 0 -2rem;
    }
  }
</style>

<style lang="sass">
  #myChart26
    margin: -3.5rem 0 0 0rem
    height: 51px !important
    width: 136px !important

  #valorPagoCP
    margin: 0 0 0 1.7rem
    font-weight: bold

  #valorPagoRecebidoId
    font-size: 17px
    display: grid
    align-items: center
    margin: -5.5rem 0 0 -1.5rem
    font-weight: bold

  #iconLinkDetalhePago
    margin: -5.5rem 0 0 0.5rem

</style>
